import {Component, computed, effect, inject, OnInit} from '@angular/core';
import {
  CreateTaStepContainerComponent
} from "../../components/create-ta/create-ta-step-container/create-ta-step-container.component";
import {CreateTaTimelineComponent} from "../../components/create-ta/create-ta-timeline/create-ta-timeline.component";
import {Button} from "primeng/button";
import {TaAppStore} from '../../../state/clcta-store';
import {ActivatedRoute, Router, UrlSegment} from '@angular/router';
import {Dialog} from 'primeng/dialog';
import {Checkbox} from 'primeng/checkbox';
import {FormsModule} from '@angular/forms';
import {LoadingService} from '../../../services/loading.service';
import {TaSubmissionDatasource} from '../../../datasources/ta-submission.datasource';
import {TAStatus} from '../../../api';
import {CreateTaTitleBarComponent} from '../../components/create-ta/create-ta-title-bar/create-ta-title-bar.component';
import {PermissionService} from '../../../services/permission.service';

@Component({
  selector: 'clc-create-ta-page',
  imports: [
    CreateTaStepContainerComponent,
    CreateTaTimelineComponent,
    Button,
    Dialog,
    Checkbox,
    FormsModule,
    CreateTaTitleBarComponent,
  ],
  templateUrl: './clc-create-ta-page.html',
  styleUrl: './clc-create-ta-page.scss'
})
export class ClcCreateTaPage implements OnInit {
  store = inject(TaAppStore);
  loadingService = inject(LoadingService);
  taSubmissionDatasource = inject(TaSubmissionDatasource);
  router = inject(Router);
  route  = inject(ActivatedRoute);
  permissionService = inject(PermissionService);

  taInfoModalDontShowSetting: boolean = false;
  taInfoModalVisible = false;
  taStatus= computed<TAStatus | undefined>(() => this.store.taSubmission()?.status);

  constructor() {
    // If the user manual enters the create page when the TA is not in progress
    // they get auto routed to the manage version of the same page. Same for review-ta-page.
    effect(() => {
      const status = this.taStatus();
      const id = this.store.taSubmission()?.id;
      if (status !== 'InProgress' && id) {
        this.router.navigate([`/ta/${id}/manage`]);
      }
    });
    // Re-run once the TA loads: a flight-only TA has its own prefix and icon.
    effect(() => {
      const flightOnly = this.taSubmissionDatasource.isFlightOnly();
      this.store.updateBreadCrumbData({
        title: 'Create TA',
        taNumberPrefix: flightOnly ? 'Flights Only ' : 'Create ',
        titleIcon: flightOnly ? 'fa-solid fa-plane fa-lg' : 'fa-regular fa-location-dot fa-lg',
        showTaComments: true,
        showSaveStatus: true,
      });
    });
  }

  ngOnInit() {
    this.taInfoModalVisible = !this.store.dontShowCreateTaDialog();
  }

  showDialog() {
    this.taInfoModalVisible = true;
  }

  closeDialog() {
    this.taInfoModalVisible = false;
    this.setTaInfoModalShowSetting();
  }

  setTaInfoModalShowSetting() {
    this.localStorage.setItem('taInfoModalDontShowSetting', JSON.stringify(this.taInfoModalDontShowSetting));
    this.store.updateDontShowCreateTaDialog(this.taInfoModalDontShowSetting);
  }

  revealStore(): void {
    console.log('revealStore', this.store.taSubmission() );
  }

  protected readonly localStorage = localStorage;
}
